//@flow

import Storage from '../protocol/Storage';
import _ from 'lodash';
import moment from 'moment';

const debug = require('../debug/debug')('wc:i18n:I18n');

class I18n {
  static _instance: I18n;
  locales: Array<Locale>;
  current: Locale;
  defaultLocal: Locale;
  dictionary: any; //var for hold object of selected language.
  defDictonary: any; //Default dictonary use for return when key not present in other language
  memoizeKeyFunc: Function;

  constructor() {
    this.dictionary = null;
    this.defDictonary = null;
    this.setup();
    this.setupDefaultLocale();
    this.defaultLocal = this.locales[0];
    this.defDictonary = window && window.locale ? window.locale[this.defaultLocal.key] : {};
    this.dictionary = window && window.locale ? window.locale[this.current.key] : {};
    this.memoizeKeyFunc = _.memoize(this.resolveKeyToValue);
    moment.locale(this.current.key);
  }

  setupDefaultLocale() {
    let defaultLocale: ?string = Storage.get('LANG'); //window.defaultLocale;
    //if (defaultLocale === null || defaultLocale === undefined) {
    //      defaultLocale = Storage.get('LANG');
    // }
    if (defaultLocale === null || defaultLocale === undefined) {
      defaultLocale = this.locales[0].key;
    }
    for (let index = 0; index < this.locales.length; index++) {
      const element: Locale = this.locales[index];
      if (element.key === defaultLocale) {
        this.current = element;
        break;
      }
    }

    if (!this.current) {
      this.current = this.locales[0];
    }
    if (debug.enabled) {
      debug('[setupDefaultLocale()] Chosen Locale: %s %s', this.current.key, this.current.name);
    }
  }

  setup() {
    this.locales = [];
    this.locales.push(new Locale('en_US', 'English (US)')); //Default is en. Do not change the order. Zeroth index is used as default locale.
    this.locales.push(new Locale('de', 'Deutsche (German)'));
    // this.locales.push(new Locale('es', 'Español(Spanish)'));
  }

  getCurrentLocale(): Locale {
    return this.current;
  }

  getSupportedLocales(): Array<{ key: string, name: string }> {
    return this.locales.map(function(l: Locale) {
      return { key: l.key, name: l.name };
    });
  }

  getListOfLocales(): Array<Locale> {
    return this.locales;
  }

  setDefaultLocale(key: string) {
    if (!key) {
      throw new Error('Null locale key.');
    }
    let found: boolean = false;
    for (let index = 0; index < this.locales.length; index++) {
      const element: Locale = this.locales[index];
      if (element.key === window['locale.' + key]) {
        found = true;
        Storage.set('LANG', key);
        break;
      }
    }
    if (found === false) {
      throw new Error('Unsupported locale key: ' + key);
    }
  }

  format(str: string, o: Object): string {
    const args = Object.keys(o);
    for (var i = 0; i < args.length; i++) {
      var regexp = new RegExp('\\${' + args[i] + '\\}', 'gi');
      str = str.replace(regexp, o[args[i]]);
    }
    return str;
  }

  getDictionary = (): any => {
    return window['locale' + this.current.key]; // this.dictionary;
  };

  resolveKeyToValue(key: string) {
    const i18nJson = this.dictionary;
    let getKeys: Array<string> = key.split('.');
    let value: string = _.get(i18nJson, getKeys);
    if (!value || value === undefined) {
      console.warn('[', this.current.key, ']', 'Key not found: ', key);
      if (this.current.key != this.defaultLocal.key) {
        //check current is not default
        value = _.get(this.defDictonary, getKeys);
      }
      if (!value || value === undefined) {
        //const childKey = getKeys[getKeys.length - 1];
        return key; //return key when key not in object
      }
    }
    return value;
  }

  get(key: string, object: Object): string {
    try {
      let value = this.memoizeKeyFunc(key);
      if (!_.isEmpty(object)) {
        value = value ? this.format(value, object) : value + ' ' + JSON.stringify(object);
      }
      return value;
    } catch (e) {
      console.log(e);
      return key;
    }
  }

  has(key: string): boolean {
    return !!key && this.memoizeKeyFunc(key) != key;
  }
}

export class Locale {
  key: string;
  name: string;
  path: string;

  constructor(key: string, name: string) {
    this.key = key;
    this.name = name;
    this.path = './dist/locale/' + key + '.json';
  }
}

//Instance of I18n class
export const initI18n = function() {
  if (!I18n._instance) I18n._instance = new I18n();
  return I18n._instance;
};

//Use t() function
//Import t from I18n class
//ADD key into en_us.json file
//if you want to pass parameter into string put ${KEY_NAME}
//Example STR:"My name is ${FIRSTNAME} ${LASTNAME}"
// pass parameter into function t('STR',{FIRSTNAME:"your value",LASTNAME:"your data"});
export default function t(key: string, vargs: Object = null): string {
  return I18n._instance.get(key, vargs);
}

export function i18nHas(key: string): boolean {
  return I18n._instance.has(key);
}

//return list of supported language
export const getListOfLocales = function(): Array<Locale> {
  return I18n._instance.getListOfLocales();
};

//Currently use language
export const getCurrentLocal = function(): Locale {
  return I18n._instance.getCurrentLocale();
};
